import {
	ADD_CONCURRENT_USER,
	REMOVE_CONCURRENT_USER,
	SET_AP_POSTING_PROGRESS,
	SET_DISPLAY_CONCURRENT_USERS,
	SET_CONCURRENT_USERS,
	ADD_GROUP_LOCK,
	SET_GROUP_LOCK,
	SET_GROUP_LOCK_ENABLED,
	REMOVE_GROUP_LOCK,
	SET_GROUP_NAME,
	REMOVE_TOAST,
	ADD_TOAST
} from './communication-hub-mutation-types';
import {
	REMOVE_GROUP_LOCK_ACTION,
	SEND_REMOVE_GROUP_LOCK_ACTION,
	ADD_GROUP_LOCK_ACTION,
	SEND_ADD_GROUP_LOCK_ACTION,
	GET_GROUP_LOCK_ACTION,
	SEND_GET_GROUP_LOCK_ACTION,
	RECEIVE_MESSAGE_ACTION
} from './communication-hub-action-types';
import {
	JOIN_GROUP_METHOD,
	LEAVE_GROUP_METHOD,
	GET_COMMUNICATION_METHOD
} from './communication-hub-methods';
import Vue from 'vue';
import store from '@/store/index.js';
import { v4 as uuidv4 } from 'uuid';
import { isEmpty, clone } from 'lodash';

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: 'communicationHub',
	namespaced: true,
	state: {
		concurrentUsers: {},
		locks: {},
		/*
			{
				'groupName':
					{
						EmployeeId: 1,
						GroupName: 'group'
						Section: 'Deals'
						DisplayName: 'deal'
						...
					}
			}
		*/
		apPostingProgress: {},
		/* Object Example
		{
			checkCount: 10,
			currentCheckIndex: 5,
			complete: false,
			currentVendor: {
				id: 123,
				vendorName: 'Vendor A',
				invoiceCount: 2,
			}
		} */
		hubConnection: undefined,
		displayConcurrentUsers: false,
		lockEnabled: false,
		hubReady: false,
		hubLogLevel: process.env.VUE_APP_LOG_LEVEL,
		groupName: null,
		activeToasts: []
	},
	mutations: {
		[ADD_CONCURRENT_USER](state, message) {
			const currentUser = store.getters['user/userInfo'];

			if (currentUser && currentUser.EmployeeId) {
				if (message.EmployeeId == currentUser.EmployeeId) {
					//don't add yourself to the current user list
					return;
				}
			}

			if (!state.concurrentUsers[message.GroupName]) {
				Vue.set(state.concurrentUsers, message.GroupName, []);
			} else {
				//see if user is already in the array of concurrent users
				const index = state.concurrentUsers[
					message.GroupName
				].findIndex(u => u.EmployeeId === message.EmployeeId);

				//if exists, remove and re-add in case new info is in the message
				if (index >= 0) {
					state.concurrentUsers[message.GroupName].splice(index, 1);
				}
			}

			state.concurrentUsers[message.GroupName].splice(0, 0, message);
		},
		[ADD_GROUP_LOCK](state, { groupName, data }) {
			Vue.set(state.locks, groupName, data);
		},

		[REMOVE_GROUP_LOCK](state, message) {
			Vue.set(state.locks, message.GroupName, undefined);
		},
		[REMOVE_CONCURRENT_USER](state, message) {
			if (state.concurrentUsers[message.GroupName]) {
				//find the user
				const index = state.concurrentUsers[
					message.GroupName
				].findIndex(u => u.EmployeeId === message.EmployeeId);

				//if exists, remove
				if (index >= 0) {
					state.concurrentUsers[message.GroupName].splice(index, 1);
				}
			}
		},
		[SET_AP_POSTING_PROGRESS](state, message) {
			state.apPostingProgress = message;
		},
		[SET_DISPLAY_CONCURRENT_USERS](state, displayConcurrentUsers) {
			state.displayConcurrentUsers = displayConcurrentUsers;
		},
		[SET_GROUP_LOCK_ENABLED](state, lockEnabled) {
			state.lockEnabled = lockEnabled;
		},
		[SET_CONCURRENT_USERS](state, data) {
			const currentUser = store.getters['user/userInfo'];
			let index;
			let users = data.Users;

			if (users) {
				users = users.filter(u => u !== null && u !== undefined);

				index = users.findIndex(
					u => u.EmployeeId == currentUser.EmployeeId
				);

				//remove current user from list if there
				if (index >= 0) {
					users.splice(index, 1);
				}
			}

			Vue.set(state.concurrentUsers, data.GroupName, users);
		},
		[SET_GROUP_LOCK](state, data) {
			Vue.set(state.locks, data.GroupName, data.Locks);
		},
		[REMOVE_GROUP_LOCK](state, groupName) {
			Vue.set(state.locks, groupName, []);
		},
		[SET_GROUP_NAME](state, groupName) {
			state.groupName = groupName;
		},
		[REMOVE_TOAST](state, id) {
			let toastIndex = state.activeToasts.findIndex(t => t.id === id);

			if (toastIndex >= 0) {
				state.activeToasts.splice(toastIndex, 1);
			}
		},
		[ADD_TOAST](state, toast) {
			let toastIndex = state.activeToasts.findIndex(
				t => t.id === toast.id
			);

			if (toastIndex >= 0) {
				state.activeToasts.splice(toastIndex, 1, toast);
			} else {
				state.activeToasts.push(toast);
			}
		}
	},
	actions: {
		/**
		 *Called from page-mixin when user visits page
		 * @param {*} param0
		 * @param {*} param1
		 */
		// eslint-disable-next-line no-unused-vars
		addConcurrentUserAction({ dispatch }, { groupName, user }) {
			const userClone = { ...user, GroupName: groupName };
			dispatch(
				'hub/invokeHubMethodAction',
				{
					message: {
						mutations: [`communicationHub/${ADD_CONCURRENT_USER}`],
						groupName: groupName,
						data: userClone,
						getMembership: true,
						dealershipGroupId: user.AspNetCompaniesId,
						companyId: user.CurrentEmployeeCompanyId
					},
					method: JOIN_GROUP_METHOD
				},
				{ root: true }
			);
		},
		removeConcurrentUserAction({ dispatch }, { groupName, user }) {
			const userClone = { ...user, GroupName: groupName };

			dispatch(
				'hub/invokeHubMethodAction',
				{
					message: {
						mutations: [
							`communicationHub/${REMOVE_CONCURRENT_USER}`
						],
						groupName: groupName,
						data: userClone,
						dealershipGroupId: user.AspNetCompaniesId,
						companyId: user.CurrentEmployeeCompanyId
					},
					method: LEAVE_GROUP_METHOD
				},
				{ root: true }
			);
		},
		[ADD_GROUP_LOCK_ACTION]({ commit, state }, data) {
			var groupName = data.GroupName;
			commit(ADD_GROUP_LOCK, { groupName, data });
			if (groupName == state.groupName) {
				window.dispatchEvent(
					new CustomEvent('vue-concurrent-users-receive', {
						detail: {
							action: `communicationHub/${ADD_GROUP_LOCK}`,
							groupName: groupName,
							data
						}
					})
				);
			}
		},
		[SEND_ADD_GROUP_LOCK_ACTION]({ dispatch }, { groupName, lock }) {
			const currentUser = store.getters['user/userInfo'];
			dispatch(
				'hub/invokeHubMethodAction',
				{
					message: {
						actions: [`communicationHub/${ADD_GROUP_LOCK_ACTION}`],
						groupName: groupName,
						data: lock,
						serverAction: 'Persist',
						persistKey: `${groupName}_lock`,
						dealershipGroupId: currentUser.AspNetCompaniesId,
						companyId: currentUser.CurrentEmployeeCompanyId,
						excludeSenderConnection: false,
						persistExpirationSeconds: 480
					}
				},
				{ root: true }
			);
		},
		[SEND_GET_GROUP_LOCK_ACTION]({ dispatch }, { groupName, lock }) {
			const currentUser = store.getters['user/userInfo'];
			dispatch(
				'hub/invokeHubMethodAction',
				{
					message: {
						actions: [`communicationHub/${GET_GROUP_LOCK_ACTION}`],
						groupName: groupName,
						persistKey: `${groupName}_lock`,
						data: lock,
						dealershipGroupId: currentUser.AspNetCompaniesId,
						companyId: currentUser.CurrentEmployeeCompanyId,
						excludeSenderConnection: false
					},
					method: GET_COMMUNICATION_METHOD
				},
				{ root: true }
			);
		},
		[GET_GROUP_LOCK_ACTION]({ commit, state }, data) {
			var groupName = data.GroupName;
			commit(ADD_GROUP_LOCK, {
				groupName,
				data
			});
			if (groupName == state.groupName) {
				window.dispatchEvent(
					new CustomEvent('vue-concurrent-users-receive', {
						detail: {
							action: `communicationHub/${ADD_GROUP_LOCK}`,
							groupName: groupName,
							data
						}
					})
				);
			}
		},

		[REMOVE_GROUP_LOCK_ACTION]({ commit, state }, data) {
			var groupName = data.GroupName;
			commit(REMOVE_GROUP_LOCK, {
				groupName: groupName,
				data
			});
			if (groupName == state.groupName) {
				window.dispatchEvent(
					new CustomEvent('vue-concurrent-users-receive', {
						detail: {
							action: `communicationHub/${REMOVE_GROUP_LOCK}`,
							groupName: groupName,
							data
						}
					})
				);
			}
		},

		[SEND_REMOVE_GROUP_LOCK_ACTION]({ dispatch }, { groupName, lock }) {
			const currentUser = store.getters['user/userInfo'];
			dispatch(
				'hub/invokeHubMethodAction',
				{
					message: {
						actions: [
							`communicationHub/${REMOVE_GROUP_LOCK_ACTION}`
						],
						groupName: groupName,
						data: lock,
						serverAction: 'Remove',
						persistKey: `${groupName}_lock`,
						dealershipGroupId: currentUser.AspNetCompaniesId,
						companyId: currentUser.CurrentEmployeeCompanyId,
						excludeSenderConnection: false,
						persistExpirationSeconds: 480
					}
				},
				{ root: true }
			);
		},
		setDisplayConcurrentUsersAction(
			{ commit },
			{ displayConcurrentUsers, groupName }
		) {
			commit(SET_DISPLAY_CONCURRENT_USERS, displayConcurrentUsers);
			commit(SET_GROUP_NAME, groupName);
		},
		setGroupLockEnabledAction({ commit }, lockEnabled) {
			commit(SET_GROUP_LOCK_ENABLED, lockEnabled);
		},
		setAPPostingProgress({ commit }, apPostingProgress) {
			commit(SET_AP_POSTING_PROGRESS, apPostingProgress);
		},
		showToastAction(
			{ commit },
			{
				title,
				subtitle,
				message,
				dismissibleTime,
				state,
				iconClassName,
				siteLevel
			}
		) {
			commit(ADD_TOAST, {
				title,
				subtitle,
				message,
				dismissibleTime,
				state,
				iconClassName,
				siteLevel,
				id: uuidv4()
			});
		},
		dismissToastAction({ commit }, id) {
			commit(REMOVE_TOAST, id);
		},
		// eslint-disable-next-line no-unused-vars
		[RECEIVE_MESSAGE_ACTION]({ state }, data) {
			var groupName = data.groupName;
			if (groupName == state.groupName) {
				window.dispatchEvent(
					new CustomEvent('vue-concurrent-edits-receive', {
						detail: {
							groupName: groupName,
							data: data
						}
					})
				);
			}
		}
	},
	getters: {
		concurrentUsers: state => state.concurrentUsers,
		concurrentUsersByGroup: state => group => {
			var groupUsers = clone(state.concurrentUsers[group] || []);
			var lock = state.locks[group] || {};

			return groupUsers.map(groupUser => {
				groupUser.locked =
					lock.EmployeeId != undefined &&
					lock.EmployeeId == groupUser.EmployeeId;
				return groupUser;
			});
		},
		apPostingProgress: state => state.apPostingProgress,
		displayConcurrentUsers: state => state.displayConcurrentUsers,
		groupName: state => state.groupName,
		groupLockEnabled: state => {
			return state.lockEnabled;
		},
		isLockedByEmployeeId: state => criteria => {
			var group = state.locks[criteria.groupName];
			if (isEmpty(group)) return false;
			return state.locks[criteria.groupName].find(
				user => user.EmployeeId === criteria.employeeId
			);
		},
		lockedUsersByGroup: state => group => {
			return state.locks[group];
		},
		toast: state => state.toast,
		toastVisible: state => state.toastVisible,
		toastMessage: state => {
			let message = '';

			if (state.toast) {
				message = state.toast.message;
			}

			return message;
		},
		toastState: state => {
			let tState = 'positive';

			if (state.toast) {
				tState = state.toast.state;
			}

			return tState;
		},
		toastDismissibleTime: state => {
			let dismissibleTime = 0;

			if (state.toast) {
				dismissibleTime = state.toast.dismissibleTime;
			}

			return dismissibleTime;
		},
		toastIconClassName: state => {
			let iconClassName = '';

			if (state.toast) {
				iconClassName = state.toast.iconClassName;
			}

			return iconClassName;
		},
		toastSiteLevel: state => {
			let siteLevel = true;

			if (state.toast) {
				siteLevel = state.toast.siteLevel;
			}

			return siteLevel;
		},
		activeToasts: state => state.activeToasts
	}
};
